import { render, staticRenderFns } from "./SegmentationStep.vue?vue&type=template&id=533d5559&scoped=true&"
import script from "./SegmentationStep.vue?vue&type=script&lang=js&"
export * from "./SegmentationStep.vue?vue&type=script&lang=js&"
import style0 from "./SegmentationStep.vue?vue&type=style&index=0&id=533d5559&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533d5559",
  null
  
)

export default component.exports